import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';

import { Select } from 'ui/components';

const statusOptions = [
  { value: 'active', label: 'Aktif' },
  { value: 'nonactive', label: 'Tidak Aktif' },
];

const initialState = {
  is_active: null,
};

const Filter = ({ show, onClose, ItemsTable, setCount }) => {
  const [{ is_active }, setState] = React.useState(initialState);

  const handleFilter = async (e) => {
    if (ItemsTable?.State?.filter) {
      let x = [];
      Object.keys(ItemsTable?.State?.filter).forEach((k) => {
        if (
          ItemsTable?.State?.filter[k] &&
          k !== 'start_at'
        ) {
          x.push(k);
        }
      });

      setCount(x);
    }
  };

  const handleStatus = (e) => {
    setState((prevState) => ({
      ...prevState,
      is_active: e,
    }));
    ItemsTable.filter('is_active', e?.value);
    handleFilter();
  };

  React.useEffect(() => {
    handleFilter();
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">
            Status
          </div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            options={statusOptions}
            value={is_active}
            onChange={handleStatus}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">
              Status
            </div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              options={statusOptions}
              value={is_active}
              onChange={handleStatus}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
